var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncomingCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1233_15259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 4L15 9L20 9",
    stroke: "#DC6803",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 3L15 9",
    stroke: "#DC6803",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38066 9.85323C8.07666 11.3028 9.02545 12.6615 10.227 13.8631C11.4286 15.0646 12.7872 16.0134 14.2369 16.7094C14.3616 16.7693 14.4239 16.7992 14.5028 16.8222C14.7831 16.904 15.1274 16.8453 15.3648 16.6752C15.4316 16.6274 15.4888 16.5702 15.6031 16.4559C15.9527 16.1063 16.1275 15.9315 16.3033 15.8172C16.9662 15.3862 17.8208 15.3862 18.4837 15.8172C18.6594 15.9315 18.8342 16.1063 19.1839 16.4559L19.3787 16.6508C19.9102 17.1822 20.1759 17.448 20.3202 17.7333C20.6073 18.3009 20.6073 18.9712 20.3202 19.5387C20.1759 19.8241 19.9102 20.0898 19.3787 20.6213L19.2211 20.7789C18.6915 21.3085 18.4267 21.5733 18.0666 21.7756C17.6671 22 17.0466 22.1614 16.5884 22.16C16.1755 22.1588 15.8932 22.0787 15.3288 21.9185C12.2954 21.0575 9.43303 19.433 7.04505 17.045C4.65707 14.6571 3.03259 11.7947 2.17162 8.76131C2.01142 8.19687 1.93131 7.91464 1.93008 7.5017C1.92872 7.04347 2.09008 6.42298 2.3145 6.02348C2.51675 5.66344 2.78156 5.39863 3.31119 4.86901L3.46882 4.71138C4.00026 4.17993 4.26598 3.91421 4.55136 3.76987C5.11893 3.4828 5.78919 3.4828 6.35675 3.76987C6.64213 3.91421 6.90785 4.17993 7.4393 4.71137L7.63417 4.90624C7.98377 5.25585 8.15858 5.43065 8.27286 5.60643C8.70386 6.26932 8.70386 7.1239 8.27286 7.78679C8.15858 7.96257 7.98377 8.13737 7.63417 8.48698C7.51985 8.60129 7.4627 8.65845 7.41486 8.72526C7.24485 8.96269 7.18614 9.30695 7.26787 9.5873C7.29087 9.66619 7.3208 9.72854 7.38066 9.85323Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1233_15259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomingCall);
export default __webpack_public_path__ + "aa447d4c1a0d797588c3d832475a92ab.svg";
export { ForwardRef as ReactComponent };